import gtm from 'eco-design-reliance/gtm';
import { ItfGTM65Entire, ItfGTM65 } from './type';

// https://docs.google.com/spreadsheets/d/11MquSBS3Lo7WJsZg_bbcDfNOefHKrr0P_YgD7qeBGFQ/edit?pli=1&gid=370435365#gid=370435365
// 【No4.用户行为】Sheet
export const handle_GTM_65 = (data: ItfGTM65) => {
    gtm.push({ ...data, event: 'uaEvent', event_name: 'support_navigation' } as ItfGTM65Entire);
};
